import { type MouseEventHandler } from 'react'

interface Props {
  id?: string
  label: string
  className?: string
  validity?: any
  landing?: boolean
  handleSubmit?: MouseEventHandler<HTMLButtonElement>
}

const Button = ({ id, label, className = '', landing, validity, handleSubmit }: Props) => {
  return (
    <button className={className} id={id} disabled={landing ? false : validity} onClick={handleSubmit}>
      {label}
    </button>
  )
}

export default Button
